'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Drawer, Heading, LoadingIndicator, ProductMediaBlock, SelectField, TextPassage } from '@petsmart-ui/sparky';
import { HTMLAttributes } from 'react';
import { ProductHit } from '@libs/algolia';
import { clsx } from '@libs/common-next';
import { Product } from './types';
import { useQuickAtc } from './useQuickAtc';
import './SetUpAutoshipButton.scss';
interface SetUpAutoshipButtonProps extends HTMLAttributes<HTMLButtonElement> {
  product: Product | ProductHit;
  className: string;
}
export function SetUpAutoshipButton(t0) {
  const $ = _c(45);
  let className;
  let product;
  let props;
  if ($[0] !== t0) {
    ({
      product,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = product;
    $[3] = props;
  } else {
    className = $[1];
    product = $[2];
    props = $[3];
  }
  const {
    id,
    isCaseRequiredSTH,
    customCaseQuantity
  } = product;
  let t1;
  if ($[4] !== customCaseQuantity || $[5] !== id || $[6] !== isCaseRequiredSTH) {
    t1 = {
      id,
      isCaseRequiredSTH,
      customCaseQuantity
    };
    $[4] = customCaseQuantity;
    $[5] = id;
    $[6] = isCaseRequiredSTH;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const {
    addedToCart,
    closeDrawer,
    frequencyItems,
    handleFormSubmit,
    isLoading,
    isDrawerOpen,
    onFrequencyChange,
    openDrawer,
    selectedFrequency
  } = useQuickAtc(t1);
  const t2 = addedToCart ? "Edit Autoship" : "Set-Up Autoship";
  const t3 = addedToCart && "add-to-cart-button add-to-cart-button__green";
  let t4;
  if ($[8] !== t3) {
    t4 = clsx(t3);
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== openDrawer || $[11] !== props || $[12] !== t2 || $[13] !== t4) {
    t5 = <Button type="submit" variant="primary" text={t2} className={t4} iconName="autoship-outline" data-testid="exp-quick-add-to-cart-open-drawer-button" onClick={openDrawer} {...props} />;
    $[10] = openDrawer;
    $[11] = props;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== className || $[16] !== t5) {
    t6 = <div className={className}>{t5}</div>;
    $[15] = className;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Drawer.Header><Heading id="drawer-heading" tagName="h2" size="headline" className="opti-quick-atc-drawer-drawer__header">Set Up Autoship</Heading></Drawer.Header>;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isLoading) {
    t8 = isLoading && <LoadingIndicator data-testid="exp-quick-add-to-cart-loading" className="transparent-overlay-loader" />;
    $[19] = isLoading;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TextPassage className="opti-quick-atc-drawer-drawer__title">Choose how often you want your item</TextPassage>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = product.images?.small;
  const t11 = `${product.name} ${product.flavor?.value ?? ""} ${product.size?.solidSize ?? ""}`;
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <ProductMediaBlock imgSrc={t10} description={t11} priceVariant="disabled" className="opti-quick-atc-drawer__item-description" aria-disabled={true} />;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== frequencyItems || $[26] !== onFrequencyChange || $[27] !== selectedFrequency) {
    t13 = <SelectField className="opti-quick-atc-drawer__frequency" label="Frequency" data-testid="exp-quick-add-to-cart-select-frequency" value={selectedFrequency} items={frequencyItems} onChange={onFrequencyChange} />;
    $[25] = frequencyItems;
    $[26] = onFrequencyChange;
    $[27] = selectedFrequency;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Button className="opti-quick-atc-drawer__button" variant="primary" text="Add to cart" fullWidth={true} data-testid="exp-quick-add-to-cart-button" />;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== handleFormSubmit || $[31] !== t13) {
    t15 = <form onSubmit={handleFormSubmit} data-testid="exp-quick-add-to-cart-form">{t13}{t14}</form>;
    $[30] = handleFormSubmit;
    $[31] = t13;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t12 || $[34] !== t15 || $[35] !== t8) {
    t16 = <Drawer.Body>{t8}{t9}{t12}{t15}</Drawer.Body>;
    $[33] = t12;
    $[34] = t15;
    $[35] = t8;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== closeDrawer || $[38] !== isDrawerOpen || $[39] !== product.id || $[40] !== t16) {
    t17 = <Drawer key={product.id} isActive={isDrawerOpen} onClose={closeDrawer} align="right" ariaLabelledBy="drawer-heading" className="opti-quick-atc-drawer" data-testid="opti-quick-atc-drawer">{t7}{t16}</Drawer>;
    $[37] = closeDrawer;
    $[38] = isDrawerOpen;
    $[39] = product.id;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t17 || $[43] !== t6) {
    t18 = <>{t6}{t17}</>;
    $[42] = t17;
    $[43] = t6;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
}